export default {
      id: "drag-lines-usage",
      viewBox: "0 0 12 6",
      url: __webpack_public_path__ + "sprite.svg#drag-lines-usage",
      toString: function () {
        return this.url;
      }
    }